export default __webpack_public_path__ + "static/media/steven-roe.766a3ebe.jpg";